import { render, staticRenderFns } from "./StoresInformation.vue?vue&type=template&id=637761fc&scoped=true&"
import script from "./StoresInformation.vue?vue&type=script&lang=js&"
export * from "./StoresInformation.vue?vue&type=script&lang=js&"
import style0 from "./StoresInformation.vue?vue&type=style&index=0&id=637761fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637761fc",
  null
  
)

export default component.exports